export default __webpack_public_path__ + "d34826415afe97cb7f42402d42ac5dfb.woff";